$(document).ready(function () {
      
    //HEADER SPACE
    function header_height() {
      var hd_height = $('.header').outerHeight();
      $('.wrapper').css("margin-top", hd_height);
      $('.col_filter').css("top", hd_height);
      $('.mini_cart_drower').css("top", hd_height + 10);
    }

    //HERO BANNER HEIGHT
    function heroHeight() {
        var winHeight = $(window).outerHeight();
        $('.hero_banner').css("height", winHeight);
    }
    // function footerHeight() {
    //     var ftHeight = $('.footer').outerHeight();
    //     $('body').css("padding-bottom", ftHeight)
    // }

    //
    function wrap_height() {
      var wrapHeight = $(window).outerHeight() - $('.header').outerHeight();
      $('.wrapper').css("min-height", wrapHeight);
    }

    //footerHeight();
    heroHeight();
    header_height();
    wrap_height();
    $(window).on('resize', function () {
      heroHeight();
    });
    $(window).on('resize orientationchange', function () {
        //  footerHeight();
        hideHeader();
        header_height();
        wrap_height();
    });


    //HEADER STICKY
    $(window).scroll(function () {
        var sticky = $('.header'), scroll = $(window).scrollTop();
      
        var hdHeight = $(".hero_banner").outerHeight() - $(".header").outerHeight();
        if (scroll >= hdHeight) sticky.addClass('sticky_header');
        else sticky.removeClass('sticky_header');

      if($('.more-img-txt.setbottom').length > 0){
        var newscroll = $(window).scrollTop()+$(window).outerHeight();
        var tt = $('.pdp_slide_inner:last').offset().top;
        if (scroll >= 100 && tt > newscroll){
            $('.more-img-txt.setbottom').slideDown();
            $('.more-img-txt:not(.setbottom)').slideUp();
        }else{
            $('.more-img-txt.setbottom').slideUp();
            $('.more-img-txt:not(.setbottom)').slideDown();
        }
      }

      if ($('.blog_tags_category').length > 0) {
        var headerHeight = $('.header').outerHeight(), navHeight = $('.blog_tags_category').outerHeight(), stickyHeight = headerHeight + navHeight;
         if (scroll > stickyHeight){
            $(".blog_tags_category").addClass("sticky");
            $(".blog_tags_category.sticky").css("top", headerHeight+'px');
         } else {
           $(".blog_tags_category").removeClass("sticky");
           $(".blog_tags_category.sticky").css("top", "0");
         }
      }
    });


    //MENU HOVER
    $(".header_menu>ul>li").hover(function () {
      $(this).toggleClass("result_hover");
      $('.header').toggleClass("header_hover");
      if($(this).hasClass('megaparent')&&$('.header_controller .search_bar').hasClass('search_open')){
        $('.header_controller .search_bar').removeClass("search_open");
        $('.header').removeClass("header_search_open");
      }
    });
    $(".header_controller ul li").hover(function () {
      $(this).toggleClass("result_hover");
      $('.header').toggleClass("header_hover");
    });

    //SEARCH OPEN
    $("body").on('click', '.search_bar>a, .search_close', function () {
      $('.search_bar').toggleClass("search_open");
      $('.header').toggleClass("header_search_open");
      setTimeout(function(){
        $('#Search_input').filter(':visible').focus();
      },100);
      if($('.col_fl_tp_right h6').length > 0 && $('.col_fl_tp_right h6').hasClass('active_filter')){
        $('.col_fl_tp_right h6').toggleClass('active_filter');
        $('.col_filter_bottom').slideToggle();
      }
    });

    //NEWSLATTER CLOSE
    setTimeout(function () {
        $('.newslatter_wp').addClass('active');
    }, 5000);
    $(".newslatter_wp .nsw_close").click(function () {
        $('.newslatter_wp').removeClass('active');
    });

    //MESONRY
    // $('.mesonry_grid').masonry({
    //     itemSelector: '.inner_grid',
    //     gutter: 15
    // });
    function check_masonary(){
      if($('.mesonry_grid').length > 0){
        $('.mesonry_grid').each(function(){
          var load = true;
          $(this).find('img').each(function(){
            if($(this).height() < 1){
              load = false;
            }
          }); 
          if(load){
            //MESONRY
           $(this).masonry({
                itemSelector: '.inner_grid',
                gutter: 0
            });    
          }else{
            setTimeout(function(){
              check_masonary();
            },1000);
          }
        });
      }else{
        setTimeout(function(){
          check_masonary();
        },1000);
      }
    }
    check_masonary();

    /// MOBILE MENU OPEN
    $('.hamburger_icon').click(function () {
        $(this).toggleClass('open');
        $('.header_center').toggleClass('active_menu');
        $('.header, body').toggleClass('active_wp_menu');
    });

    //MEGAMENU MOBILE
    $('.acnav__label').click(function (e) {
        e.preventDefault();
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav__list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });

    //FILTER OPEN
    $("body").on('click', '.col_fl_tp_right h6', function () {
        $(this).toggleClass('active_filter');
        $('.col_filter_bottom').slideToggle();
    });

   //Open MINI CART	
    $("body").on('click', '.hd_mini_cart a', function () {	
      $('.mini_cart_wp_main, body').addClass('active');	
      if($('.header_controller .search_bar').hasClass('search_open')){
        $('.header_controller .search_bar').removeClass("search_open");
      }
      if($('.col_fl_tp_right h6').length > 0 && $('.col_fl_tp_right h6').hasClass('active_filter')){
        $('.col_fl_tp_right h6').toggleClass('active_filter');
        $('.col_filter_bottom').slideToggle();
      }
    });	
    $("body").on('click', '.mini_cart_close, .mini_cart_overlay', function () {	
        $('.mini_cart_wp_main, body').removeClass('active');	
        $('.header').removeClass('header_search_open');
    });


    //FOOTER HEIGHT
    function hideHeader() {
        $(window).scroll(function () {
            var wpHeight = $('.wrapper').outerHeight() - $('.footer').outerHeight() / 2;
            var sticky = $('.header, .col_filter'),
                scroll = $(window).scrollTop();
            if (scroll >= wpHeight) sticky.addClass('hide_header');
            else sticky.removeClass('hide_header');
        });
    }
    hideHeader();
    
  

    //NICE SELECT
    $('.nice-select').each(function () {

        var select = $(this),
            name = select.attr('name');

        select.hide();
        select.wrap('<div class="nice-select-wrap"></div>');
        var parent = select.parent('.nice-select-wrap');
        parent.append('<ul id="' + name + '" style="display:none"></ul><div class="pdp_select_icon"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none"><path d="M1 1L6.5 6L12 1" stroke="#02053C" stroke-width="0.8"/></svg></div>');
      if (select.find('option.active')) {
          if(select.find('option.active').attr('value') == undefined){
            $('<a href="javascript:void(0);" class="drop">' + select.find('option:not([disabled]):first').attr('value') + '</a>').insertBefore(parent.find('ul'));
          }else{
            $('<a href="javascript:void(0);" class="drop">' + select.find('option.active').attr('value') + '</a>').insertBefore(parent.find('ul'));  
          }
        }
        select.find('option').each(function () {
          var option = $(this),
              value = option.attr('value') ? option.attr('value') : '',
              lclass = option.attr('class') ? option.attr('class') : 'nice-select-option',
              label = option.text(),
              isDisabled = option.attr('disabled') ? ' in-active-option' : '',
              isRedirect = option.data('redirect') ? option.data('redirect') : '',
              href = option.data('href') ? option.data('href') : '#';
          parent.find('ul').append('<li class="'+lclass+isDisabled+'"><a data-redirect="'+ isRedirect +'" href="'+ href +'" id="' + value + '">' + label + '</a></li>');
        });
        parent.find('a').on('click', function (e) {
            parent.toggleClass('down').find('ul').slideToggle(300);
            e.preventDefault();
        });
        parent.find('ul a').on('click', function (e) {          
            var niceOption = $(this),
                value = niceOption.attr('id'),
                text = niceOption.text();
            // console.log('#######',select.find('option[data-val="'+value+'"]'));
            select.val(value).change();
            $(this).parents('ul').find('li').removeClass('active');
            $(this).parent('li').addClass('active');
            $(this).parents('.nice-select-wrap').find('.drop').text(text);
            e.preventDefault();
            if ($(this).data('redirect') == true) location.href = $(this).attr('href');
        });
    });

    //PDP ACCORDION
    $("body").on('click', '.pdp_acc_title:not(.child)', function () {
      $(".pdp_acc_title").removeClass("active");
      $(".pdp_acc_content").slideUp();
      if (!$(this).next().is(":visible")) {
          $(this).next().slideDown();
          $(this).addClass("active");
      }
    });
    $("body").on('click', '.pdp_acc_title.child', function () {
      $(".pdp_acc_title.child").removeClass("active");
      $(".pdp_acc_content.child").slideUp();
      if (!$(this).next().is(":visible")) {
          $(this).next().slideDown();
          $(this).addClass("active");
      }
    });
  
    //Bespoke Form ACCORDION
    $("body").on('click', '.form_acc_title', function () {
        $(".form_acc_title").removeClass("active");
        $(".form_acc_content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });


    //FAQ ACCORDION
    $("body").on('click', '.acc_item_title', function () {
        $(".acc_item_title").removeClass("active");
        $(".acc_item_content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });


    //STOCK ACCORDION
    $("body").on('click', '.stock_accordion_title', function () {
      var $this = $(this);
        $(".stock_accordion_title").removeClass("active");
        $(".stock_content_wp").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
        setTimeout(function(){
          var headerHe = $(".header").outerHeight();
          $('html, body').animate({
              scrollTop: $this.offset().top - headerHe
          }, 500);
        }, 600);
    });


    //STONE GAIDE
    $("body").on('click', '.lg_title_main', function () {
        $(".lg_title_main").removeClass("active");
        $(".lg_acc_content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });


    //PDP SLIDER MAIN
    if($('.pdp_media_slider').length > 0) {
        (function () {
            'use strict';
            const breakpoint = window.matchMedia('(min-width:768px)');
            let mySwiper;
            const breakpointChecker = function () {
                if (breakpoint.matches === true) {
                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    return;
                } else if (breakpoint.matches === false) {
                    console.log('99999999');
                    return enableSwiper();
                }
            };
            const enableSwiper = function () {
                mySwiper = new Swiper('.pdp_media_slider', {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    dots: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      },
                });
            };
            breakpoint.addListener(breakpointChecker);
            breakpointChecker();
        })();
    }


    //CMP COLLECTION SLIDER
    if($('.pro_image_list').length > 0) {
        (function () {
            'use strict';
            const breakpoint = window.matchMedia('(min-width:641px)');
            let mySwiper;
            const breakpointChecker = function () {
                if (breakpoint.matches === true) {
                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    return;
                } else if (breakpoint.matches === false) {
                    return enableSwiper();
                }
            };
            const enableSwiper = function () {
                mySwiper = new Swiper('.pro_image_list', {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    dots: false,
                    loop: true,
                    slideToClickedSlide: true,
                    loop: true,
                    loopAdditionalSlides: 30,
                });
    
    
            };
            breakpoint.addListener(breakpointChecker);
            breakpointChecker();
        })();
    }
  
    // HOME PAGE SLIDER
    if($('.mid_col_wp_slider').length > 0) {
        (function () {
            'use strict';
            const breakpoint = window.matchMedia('(min-width:768px)');
            let mySwiper;
            const breakpointChecker = function () {
                if (breakpoint.matches === true) {
                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    return;
                } else if (breakpoint.matches === false) {
                    return enableSwiper();
                }
            };
            const enableSwiper = function () {
                mySwiper = new Swiper('.mid_col_wp_slider', {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    dots: false,
                });
            };
            breakpoint.addListener(breakpointChecker);
            breakpointChecker();
        })();
    }

  //PRODUCT
  if ($('body').hasClass('template-product')) {
    // FancySwatches(); // Commented because of the material dropdown linked with metafield
  }
  function FancySwatches() {
    if($('[data-color-product]').find('.nice-select-wrap').length > 0){
      var fullTitle = $('.product-title').attr('data-full-title');
      var noColorTitle = $('.product-title').text().trim();
      var termHandle = noColorTitle.toLowerCase().replace(/ /g,'-');
      var term = $.trim(noColorTitle).toLowerCase().split(' ').join('+');
      var searchURL = '/search?q=' + term + '&type=product&view=colors';
      if(fullTitle.indexOf("-") > 0) {
        $.getJSON(searchURL, function(data) {
          if(data.results_count > 0) {
            $('[data-color-product] select').empty();
            $('[data-color-product] ul').empty();
            $.each(data.results, function(index, item) {
              if(item.title == noColorTitle) {  
                if(item.color) {
                  if(item.color == $('.product-form-parent').attr('data-color')) {
                    $('[data-color-product] select').val(item.color);
                    $('[data-color-product] .drop').text(item.color);
                  }
                  $('[data-color-product] select').append('<option value="'+item.color+'">'+item.color+'</option>');
                  $('[data-color-product] ul').append('<li><a href="'+ item.url +'" id="' + item.color + '">' + item.color + '</a></li');
                  
                }
              }
            });
          }
        });
      }
    }else{
      setTimeout(function(){
        FancySwatches();
      },1000);
    }
  }

  // PRODUCT VARIANT CHANGE

  var add_text = window.variantStrings.addToCart;
  var sold_text = window.variantStrings.soldOut;
 function addBtnText(disable, text, btnClass) {
    if (!btnClass) {
      return;
    }
    if (disable) {
      btnClass.prop('disabled', true);
      btnClass.html(text);
      console.log('soldout');
      $('.klaviyo-bis-trigger').show();
      $('[data-add-to-cart]').hide();
    } else {
      console.log('instock');
      btnClass.prop('disabled', false);
      btnClass.html(text);
      $('.klaviyo-bis-trigger').hide();
      $('[data-add-to-cart]').show();
    }
  }
  function varaintSelect(form, _this) {
      var section = form.find('[data-product-variant]').data('section');
      var url = form.find('[data-product-variant]').data('url');
      var getVariantData = JSON.parse(form.find('[type="application/json"]').text());
      var fieldsets = form.find('.product-form__input').toArray();
      var addButton = form.find('[name="add"]');
      var options = [];
  
      $.each(fieldsets, function (i, v){ 
        var value = $(v).find("select").length > 0 ? $(v).find("select").val() : $(v).find(".no-more-options").length > 0 ? $(v).find(".no-more-options").data('val') : '';
        options.push(value);
      });
      // console.log('option=====',options);
      var currentVariant;
  
      $.each(getVariantData, function (i, variant){
        var lll = 0;
        $.each(variant.options, function (index, option){ 
          if(options[index] !== option){
            lll = 1;
          }
        });
        if(lll == 0){
          currentVariant = variant;
        }
      });
      window.history.replaceState({ }, '', url+'?variant='+currentVariant.id);
      if (!currentVariant) {
        return;
      }
      if (!currentVariant.available) {
        addBtnText(true, sold_text, addButton);
      } else {
        const input = form.find('input[name="id"]');
        input.val(currentVariant.id).trigger('change');
        input.attr('data-variant-title',currentVariant.title);
        addBtnText(false, add_text, addButton);   
      }
      var current_variant_quantity = $('.variant-inventory').find('.product-variant[data-variant-id="'+currentVariant.id+'"]').attr('data-variant-inventory-qty');
      var get_inv = parseInt($('.inventory-prompt').attr('data-stock'));
      if( $('.variant-inventory').length && current_variant_quantity>=1 && current_variant_quantity<= get_inv ){
        $('.inventory-prompt p').html('We only have '+current_variant_quantity+' left');
      }else{
        $('.inventory-prompt p').html('');
      }
      $.get(url+'?variant='+currentVariant.id+'&section_id='+section, function(data){
        const html = new DOMParser().parseFromString(data, 'text/html')
        const destination = document.getElementById(`price-${section}`);
        const source = html.getElementById(`price-${section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${section}`);

        if (price) price.classList.remove('visibility-hidden');

        const comdestination = document.getElementById(`comprice-${section}`);        
        const comsource = html.getElementById(`comprice-${section}`);
        if (comsource && comdestination) comdestination.innerHTML = comsource.innerHTML;
        
      });
      
    }

  $('body').on('change','.pdp_var_item.product-form__input select', function() {
    var form = $(this).parents('#product_form_id');
    varaintSelect(form);
  });

  function refresh_cart(){
    $.get("/cart?view=minicart", function(data) {
      $('[data-mini-cart-drawer]').html($(data).find('[data-mini-cart-drawer]').html());
       $('.mini_cart_body').find('.loader').remove();
    });
    $.getJSON("/cart", function(data) {
      $('.header_controller .hd_mini_cart span').text('('+data.item_count+')');
    });
  }
  function refresh_main_cart(){
    $.get("/cart", function(data) {
      $('section.main_cart').html($(data).find('section.main_cart').html());
    });
    $.getJSON("/cart", function(data) {
      $('.header_controller .hd_mini_cart span').text('('+data.item_count+')');
    });
  }
  function additem(id){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id, quantity: 1},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      if($('body').hasClass('template-cart')){
        refresh_main_cart(); 
      }else{
        refresh_cart();
      }
    });
  }
  $('body').on('click', '.upsell_add_to_cart', function(e) {
    e.preventDefault();
    $('.mini_cart_body').prepend('<div class="loader"></div>');
    var id= $(this).attr('data-id');
    additem(id);
  });
  $('body').on('click', '#cc-add-button:not(.cc-add-button--active)', function(e) {
    e.preventDefault();
    var id= $(this).attr('data-id');
    console.log('data-id ==', id)
    $('.mini_cart_body').prepend('<div class="loader"></div>');
    additem(id);
  });
  $('body').on('click', '.package_product_add', function(e) {
    e.preventDefault();
    var id= parseInt($(this).attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id, quantity: 1},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      refresh_main_cart();
    });
  });
  $('body').on('click', '#cc-add-button.cc-add-button--active', function(e) {
    e.preventDefault();
    var id= $(this).attr('data-id');
    $('.mini_cart_body').prepend('<div class="loader"></div>');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {updates:{[id]: 0}},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      if($('body').hasClass('template-cart')){
        refresh_main_cart();
      }else{
        refresh_cart(); 
      }
    });
  });
  $('body').on('click', '[data-add-to-cart]', function(e) {
    e.preventDefault();
    var formData = $(this).parents('form');
    var id= parseInt(formData.find('input[name="id"]').val());
    var timestamp = Date.now();
    if($('#chains').length > 0 && $('#chains [data-material] option').length > 0){
      var id2= parseInt(formData.find('select[name="chain-id"] option:checked').attr('data-id'));
      var tied = id + '.' + timestamp; 
      var data = {items: [
        {
          quantity: 1,
          id: id,
          properties:{ tied_to: tied }
        },
        {
          quantity: 1,
          id: id2,
          properties:{ tied_to: tied }
        }
      ]
     };
      
    }else{
      var data = {id:id, quantity: 1};
    }

    
    // console.log('data=',jQuery.type(data))
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      refresh_cart();
      $('.mini_cart_wp_main, body').addClass('active');
    });
  });
  function update_item(combine,id,cnt){
    if(cnt > 0){
      cnt--;
    }
    
    $('.mini_cart_body').prepend('<div class="loader"></div>');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {line:id,quantity: 0},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function(cart){
        if(cnt > 0){
          if($('body').hasClass('template-cart')){
            $.get("/cart", function(data) {
              $('.main_cart').html($(data).find('.main_cart').html());
              checkproduct(combine,cnt);
            });
          }else{
            $.get("/cart?view=minicart", function(data) {
              $('[data-mini-cart-drawer]').html($(data).find('[data-mini-cart-drawer]').html());
              checkproduct(combine,cnt);
            });
          }
        }else{
          if($('body').hasClass('template-cart')){
            refresh_main_cart();
          }else{
            refresh_cart();
          }
        }
      }
    });
  }
  function checkproduct(combine,cnt){
    var id = $('.mini_cart_items[data-combine-product="'+combine+'"]:eq(0)').attr('data-id');
    update_item(combine,id,cnt);
  }
  
  $('body').on('click', '.adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('.mini_cart_body').prepend('<div class="loader"></div>');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      if($('body').hasClass('template-cart')){
        refresh_main_cart(); 
      }else{
        refresh_cart();
      }
      
     
//      $('#crt').removeClass('loading');
    });

  });
  
  $('body').on('click','.remove_item',function(e){
    e.preventDefault();
    var id = parseInt($(this).parents('.mini_cart_items').attr('data-id'));
    var combine = $(this).parents('.mini_cart_items').attr('data-combine-product');
    var cnt = 0;
    if($('.mini_cart_items[data-combine-product="'+combine+'"]').length > 0){
      var cnt = $('.mini_cart_items[data-combine-product="'+combine+'"]').length;
    }
    // console.log('ids==',data);
    update_item(combine,id,cnt);
  });

   //ALSO LIKE SLIDER
  function product_recommendations(){
    if($('.also_like_sec .swiper-slide').length > 0){
      var swiper = new Swiper(".also_like_slide", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        slideToClickedSlide: true,
        loop: true,
        loopAdditionalSlides: 30,
        breakpoints: {
          640: {
              slidesPerView: 3,
              loop: false,
          },
          991: {
              slidesPerView: 4,
              loop: false,
          },
        },
      });
    }else{
      setTimeout(function(){
        product_recommendations();
      });
    }
  }
  product_recommendations();


   //SHOW BESPOKE FORM
    $("body").on('click', '.custom_order_link a', function () {
        $('.pdp_center_wp').addClass('not_display');
        $('.bespoke_form').removeClass('not_display_form');
    });
    $("body").on('click', '.bespoke_form .remove_form', function () {
        $('.pdp_center_wp').removeClass('not_display');
        $('.bespoke_form').addClass('not_display_form');
    });


    // CUSTOM UPLOADER
    $(function () {
        var countFiles = 1,
            $body = $('body'),
            typeFileArea = ['txt', 'doc', 'docx', 'ods'],
            coutnTypeFiles = typeFileArea.length;

        //create new element
        $body.on('click', '.files-wr label', function () {
            var wrapFiles = $('.files-wr'),
                newFileInput;

            countFiles = wrapFiles.data('count-files') + 1;
            wrapFiles.data('count-files', countFiles);

            newFileInput = '<div class="one-file"><label for="file-' + countFiles + '">Upload Reference Images</label>' +
                '<input type="file" name="file-' + countFiles + '" id="file-' + countFiles + '"><div class="file-item hide-btn">' +
                '<span class="file-name"></span><span class="btn btn-del-file">x</span></div></div>';
            wrapFiles.prepend(newFileInput);
        });

        //show text file and check type file
        $body.on('change', 'input[type="file"]', function () {
            var $this = $(this),
                valText = $this.val(),
                fileName = valText.split(/(\\|\/)/g).pop(),
                fileItem = $this.siblings('.file-item'),
                beginSlice = fileName.lastIndexOf('.') + 1,
                typeFile = fileName.slice(beginSlice);

            fileItem.find('.file-name').text(fileName);
            if (valText != '') {
                fileItem.removeClass('hide-btn');

                for (var i = 0; i < coutnTypeFiles; i++) {

                    if (typeFile == typeFileArea[i]) {
                        $this.parent().addClass('has-mach');
                    }
                }
            } else {
                fileItem.addClass('hide-btn');
            }

            if (!$this.parent().hasClass('has-mach')) {
                $this.parent().addClass('error');
            }
        });

        //remove file
        $body.on('click', '.btn-del-file', function () {
            var elem = $(this).closest('.one-file');
            elem.fadeOut(400);
            setTimeout(function () {
                elem.remove();
            }, 400);
        });
    });

  //BESPOKE FORM ACCORDIAN
  $('body').on('change','.form_accordion.check_hasornot input[type="radio"]',function(){
    var getattr = $(this).closest('.form_accordion').attr('data-type');
    var getclass = $(this).attr('id');
    $('.form_accordion.'+getattr).slideUp();
    $('.form_accordion.'+getclass).slideDown();
  });

  //BESPOKE FORM VALIDATION
  $('body').on('click','.bespoke_form .enquirey_btn',function(e){
      e.preventDefault();
      var x = true;
      var name = $('input[name="contact[name]"]');
      var email = $('input[name="contact[email]"]');
      var budget = $('textarea[name="contact[budget]"]');
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      var add_date_proper = true;
      var currDate = new Date();
      var sel_date = new Date($('#month option:checked').attr('data-val')+'/'+$('#day option:checked').attr('data-val')+'/'+$('#year option:checked').attr('data-val'));
      console.log(sel_date);
      if(currDate.getTime() >= sel_date.getTime()){
        add_date_proper = false
      }
    
      $('.bespoke_form .input_fields .errorForm, .bespoke_form .input_textarea .errorForm, .form_accordion.date_accor .errorForm').remove();

      if(budget.val() == '') {
        budget.parent().append('<div class="errorForm">Please enter your budget</div>');
        x = false;
      } else {
        budget.parent().find('.errorForm').remove();
      }

      if(add_date_proper == false) {
        $('.custom_selecter_date').parent().append("<div class='errorForm'>Don't add past date. Please select proper date.</div>");
        x = false;
      } else {
        $('.custom_selecter_date').parent().find('.errorForm').remove();
      }
    
      if(name.val() == '') {
        name.parent().append('<div class="errorForm">Please enter name</div>');
        x = false;
      } else {
        name.parent().find('.errorForm').remove();
      }
      
      if(email.val() == '' || !regex.test(email.val())) {
        email.parent().append('<div class="errorForm">Please enter valid e-mail.</div>');
        x = false;
      } else {
        email.parent().find('.errorForm').remove();
      }
      
      
      if(x==false) {
        $('html, body').animate({'scrollTop': $('.bespoke_form').offset().top }, 'slow');
        return false;
      } else{
        $(this).parents('.contact-form').submit();
      }
    });

  //CONTACT FORM VALIDATION
  $('body').on('click','.contact_section .contact_submit',function(e){
      e.preventDefault();
      var x = true;
      var name = $('input[name="contact[name]"]');
      var email = $('input[name="contact[email]"]');
      var enquiry = $('textarea[name="contact[body]"]');
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      $('.contact_section .input_wrapper .errorForm').remove();
      if(name.val() == '') {
        name.parent().append('<div class="errorForm">Please enter name</div>');
        x = false;
      } else {
        name.parent().find('.errorForm').remove();
      }
      if(email.val() == '' || !regex.test(email.val())) {
        email.parent().append('<div class="errorForm">Please enter valid e-mail</div>');
        x = false;
      } else {
        email.parent().find('.errorForm').remove();
      }
      if(enquiry.val() == '') {
        enquiry.parent().append('<div class="errorForm">Please enter Enquiry Detail</div>');
        x = false;
      } else {
        enquiry.parent().find('.errorForm').remove();
      }
      
      
      if(x==false) {
        $('html, body').animate({'scrollTop': $('.bespoke_form').offset().top }, 'slow');
        return false;
      } else{
        $(this).parents('.contact-form').submit();
      }
    });


    //PRESS POPUP
    $("body").on('click', '.press_item_right a.haspopup', function () {	
        $(this).closest('.press_item').find('.press_popup').addClass('active');
    });	
    $("body").on('click', '.press_close, .press_bk_overlay', function () {	
        $('.press_popup').removeClass('active');
    });

    //PRESS POPUP
    var swiper = new Swiper(".press_img_slide", {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".pr_swiper-button-next",
        prevEl: ".pr_swiper-button-prev",
      },
    });

  // COOKIE
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  $('body').on('click','.bg_post_inner_item a',function(e){
    setCookie("backblog", 'has_blog_back');
    return true;
  });
  if($('.template-article').length > 0){
    var user = getCookie("backblog");
    console.log(user,'backblog');
    if(user != null && user != ''){
      $('.back-next-btn .back_btn').addClass('has_history_url');
      $('body').on('click','a:not(.has_history_url)',function(){
        var href= $(this).attr('href');
        if(href.indexOf('javascript:') == -1){
          setCookie('backblog','',0);  
        }
      });
    }else{
      $('.back-next-btn .back_btn').removeClass('has_history_url');
    }
   
  }
  $('body').on('click','.back_btn.has_history_url',function(e){
    e.preventDefault();
    setCookie('backblog','',0);
    window.history.go(-1);
  });

  $('body').on('click','[id="CartDrawer-Checkout"]',function(e){
    e.preventDefault();
    var $this = $(this), form = $(this).closest('form'), notes = form.find('[name="notes"]');
    $('.checkout_error').remove();
    function checkitem(){
      $.getJSON('/cart',function(data){
        var total = parseInt($('.check_cart_total').attr('data-total'));
        var item = data.items;
        var allremove = false;
        if(data.total_price > 0){
          
          for(var i =0;i< data.item_count;i++){
            console.log(item[i],'ss')
            if(item[i]) {              
              var combine = item[i].properties['tied_to'];
              if(!item[i].price > 0 && combine == undefined && combine == null){
                $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: {updates:{[item[i].id]: 0}},
                  dataType: 'json',
                  error: function(jqXHR, textStatus, errorThrown){
                    var response = $.parseJSON(jqXHR.responseText);
                    alert(response.description);
                  },
                  success: function(cart){
                    refresh_main_cart();
                    checkitem();
                  }
                });
              }
            }
          }
        }else{
          allremove = true;
        }
        if(allremove){
          window.location = '/cart/clear';
        }else{
          //document.location.href = '/cart/checkout';
          let hidden_checkout_btn = document.querySelector('#CartDrawer-Checkout-hidden');
          if(hidden_checkout_btn){
            hidden_checkout_btn.click();
          }
        }
      });     
    }
    checkitem();
  });

  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();    
    var id = $(this).attr('href') != '#' ? $(this).attr('href') : '', $id = $(id), col_filter = 0;
    
    if ($id.length === 0) { return; }
    
    if ($('.col_filter').length) col_filter = $('.col_filter').outerHeight();
    var pos = $id.offset().top - $('.header').outerHeight() - col_filter;
    $('body, html').animate({scrollTop: pos});
  });

  $('body').on('click', '[data-more-img-txt]', function(e){
    e.preventDefault();
    var next_slide = $(this).next('.pdp_slide_inner').offset().top - $('.header').outerHeight();
    $('html, body').animate({
        scrollTop: next_slide
    }, 500);
  })
});


$(window).on('load',function() {    
  $('.uploa_imageOuterCS label').css('pointer-events','unset');
  $("#reference_images").after(`<img src="" id="reference_images_output" style="height:80px; width:80px;">`);  
  $('#reference_images_output').hide();
    var loadFile = function (event) {
    var output = document.getElementById('reference_images_output');
    output.src = URL.createObjectURL(event.target.files[0]);
    output.onload = function () {
      URL.revokeObjectURL(output.src) // free memory
    }
  };
  $("#reference_images").on("change",function(event){  
    loadFile(event)
    $('#reference_images_output').show();
  });
});
  